import React from "react";
import {Translate} from "../../../../../hooks/translate.hook";
import {ColumnsType} from "antd/es/table";
import {ArticleVehicleModelVariant} from "../../../../../models/articles/article.data";

export const columnsFactory = (t: Translate): ColumnsType<ArticleVehicleModelVariant> => {
    return [
        {
            title: t("NAME"),
            dataIndex: "model",
            key: "model",
        },
        {
            title: t("VEHICLE.BODY"),
            dataIndex: "body",
            key: "body",
        },
        {
            title: t("YEARS"),
            dataIndex: "years",
            key: "years",
            width: "130px",
            render: (item: string) => <span style={{whiteSpace: "nowrap"}}>{item}</span>
        },
        {
            title: t("ARTICLES.SUBMODEL"),
            dataIndex: "engineName",
            key: "engineName",
        },
        {
            title: t("VEHICLE.ENGINE_POWER"),
            dataIndex: "enginePower",
            key: "enginePower",
        },
        {
            title: t("VEHICLE.ENGINE_VOLUME"),
            dataIndex: "engineVolume",
            key: "engineVolume",
            render: (v: string) => <>{v} cm3</>
        },
        {
            title: t("ARTICLES.FUEL_TYPE"),
            dataIndex: "fuel",
            key: "fuel"
        }
    ];
}